<!-- @Version: 1.0.0 -->
<app-bank-logo-default data-testid="bank-logo-left"></app-bank-logo-default>

@if (showActionLogo) {
   <app-action-logo data-testid="action-logo-left"></app-action-logo>
}
